


















































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiSalaryRuleAdd, apiSalaryRuleEdit, apiSalaryRuleDetail, apiWorkerTypeList } from '@/api/staff'

@Component
export default class SalaryRuleEdit extends Vue {
    form: any = {
      rule_name: '',
      rule_type: 1,
      worker_type_id: '',
      employment_type: '',
      base_salary_type: 1,
      base_amount: 0,
      internal_base_amount: 0,
      commission_type: 0,
      commission_rate: 0,
      internal_commission_rate: 0,
      commission_rules: [{ min: 0, max: 100, rate: 5, internal_rate: 5 }],
      overtime_rate: 1.5,
      night_shift_rate: 1.2,
      holiday_rate: 2.0,
      allowance_items: [],
      deduction_rules: [],
      min_guarantee_amount: 0,
      tax_calculation: 0,
      social_insurance: 0,
      payment_cycle: 4,
      payment_day: 15,
      effective_date: null,
      expiry_date: null,
      is_default: 0,
      is_enabled: 1,
      remark: ''
    }

    rules = {
      rule_name: [
        { required: true, message: '请输入规则名称', trigger: 'blur' },
        { max: 100, message: '规则名称不能超过100个字符', trigger: 'blur' }
      ],
      rule_type: [
        { required: true, message: '请选择规则类型', trigger: 'change' }
      ],
      base_salary_type: [
        { required: true, message: '请选择基础薪酬类型', trigger: 'change' }
      ],
      base_amount: [
        { required: true, message: '请输入对外基础金额', trigger: 'blur' },
        { type: 'number', min: 0, message: '基础金额不能小于0', trigger: 'blur' }
      ],
      internal_base_amount: [
        { required: true, message: '请输入对内基础金额', trigger: 'blur' },
        { type: 'number', min: 0, message: '基础金额不能小于0', trigger: 'blur' }
      ],
      commission_rate: [
        { type: 'number', min: 0, max: 100, message: '提成比例必须在0-100之间', trigger: 'blur' }
      ],
      internal_commission_rate: [
        { type: 'number', min: 0, max: 100, message: '提成比例必须在0-100之间', trigger: 'blur' }
      ],
      payment_cycle: [
        { required: true, message: '请选择发放周期', trigger: 'change' }
      ],
      effective_date: [
        { required: true, message: '请选择生效日期', trigger: 'change' }
      ]
    }

    activeTab = 'basic'
    loading = false
    workerTypeList: any[] = []

    get isEdit () {
      return this.$route.query.id
    }

    get alertTitle () {
      return this.isEdit
        ? '温馨提示：编辑薪酬规则，修改后会影响相关员工的薪酬计算。'
        : '温馨提示：新增薪酬规则需要完善基本信息、提成设置、特殊费率等内容。'
    }

    getBaseAmountUnit () {
      switch (this.form.base_salary_type) {
        case 1: return '元/月'
        case 2: return '元/小时'
        case 3: return '元/天'
        case 4: return '元/件'
        default: return '元'
      }
    }

    handleRuleTypeChange (value: number) {
      // 根据规则类型设置基础薪酬类型
      switch (value) {
        case 1: // 时薪规则
          this.form.base_salary_type = 2
          break
        case 2: // 日薪规则
          this.form.base_salary_type = 3
          break
        case 3: // 计件规则
          this.form.base_salary_type = 4
          break
        case 4: // 提成规则
          this.form.base_salary_type = 1
          this.form.commission_type = 1
          break
      }
    }

    addCommissionRule () {
      const rules = this.normalizeJsonArray(this.form.commission_rules, [{ min: 0, max: 100, rate: 5, internal_rate: 5 }])
      rules.push({ min: 0, max: 0, rate: 0, internal_rate: 0 })
      this.form.commission_rules = rules
    }

    removeCommissionRule (index: number) {
      const rules = this.normalizeJsonArray(this.form.commission_rules, [{ min: 0, max: 100, rate: 5, internal_rate: 5 }])
      rules.splice(index, 1)
      this.form.commission_rules = rules.length ? rules : [{ min: 0, max: 100, rate: 5, internal_rate: 5 }]
    }

    addAllowanceItem () {
      const items = this.normalizeJsonArray(this.form.allowance_items)
      items.push({ name: '', amount: 0 })
      this.form.allowance_items = items
    }

    removeAllowanceItem (index: number) {
      const items = this.normalizeJsonArray(this.form.allowance_items)
      items.splice(index, 1)
      this.form.allowance_items = items
    }

    addDeductionItem () {
      const items = this.normalizeJsonArray(this.form.deduction_rules)
      items.push({ name: '', amount: 0 })
      this.form.deduction_rules = items
    }

    removeDeductionItem (index: number) {
      const items = this.normalizeJsonArray(this.form.deduction_rules)
      items.splice(index, 1)
      this.form.deduction_rules = items
    }

    /** 将接口 JSON 字段统一为数组（模型可能已解码为对象/数组/字符串） */
    normalizeJsonArray (value: any, defaultValue: any[] = []): any[] {
      if (value === null || value === undefined || value === '') {
        return [...defaultValue]
      }
      if (Array.isArray(value)) {
        return value.map(item => (typeof item === 'object' && item !== null ? { ...item } : item))
      }
      if (typeof value === 'string') {
        try {
          return this.normalizeJsonArray(JSON.parse(value), defaultValue)
        } catch {
          return [...defaultValue]
        }
      }
      if (typeof value === 'object') {
        return Object.values(value).map(item => (typeof item === 'object' && item !== null ? { ...item } : item))
      }
      return [...defaultValue]
    }

    handleSubmit () {
      (this.$refs.formRef as any).validate((valid: boolean) => {
        if (valid) {
          this.loading = true

          // 处理表单数据
          const submitData = {
            ...this.form,
            commission_rules: JSON.stringify(this.form.commission_rules),
            allowance_items: JSON.stringify(this.form.allowance_items),
            deduction_rules: JSON.stringify(this.form.deduction_rules),
            effective_date: this.form.effective_date ? Math.floor(this.form.effective_date / 1000) : null,
            expiry_date: this.form.expiry_date ? Math.floor(this.form.expiry_date / 1000) : null
          }

          const api = this.isEdit ? apiSalaryRuleEdit : apiSalaryRuleAdd
          const params = this.isEdit
            ? { id: this.$route.query.id, ...submitData }
            : submitData

          api(params).then(() => {
            this.$router.push('/staff/salary-rule')
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }

    getSalaryRuleDetail () {
      if (this.isEdit) {
        apiSalaryRuleDetail({ id: this.$route.query.id }).then((res: any) => {
          const data = res || {}
          const jsonFields = ['commission_rules', 'allowance_items', 'deduction_rules']
          Object.keys(this.form).forEach(key => {
            if (data[key] !== undefined && !jsonFields.includes(key)) {
              this.form[key] = data[key]
            }
          })

          const commissionRules = this.normalizeJsonArray(data.commission_rules, [
            { min: 0, max: 100, rate: 5, internal_rate: 5 }
          ])
          this.form.commission_rules = commissionRules.map((rule: any) => ({
            ...rule,
            internal_rate: rule.internal_rate ?? 0
          }))
          this.form.allowance_items = this.normalizeJsonArray(data.allowance_items, [])
          this.form.deduction_rules = this.normalizeJsonArray(data.deduction_rules, [])

          // 处理时间戳（秒 -> 毫秒供 date-picker）
          if (data.effective_date) {
            const ts = Number(data.effective_date)
            this.form.effective_date = ts >= 1e12 ? ts : ts * 1000
          }
          if (data.expiry_date) {
            const ts = Number(data.expiry_date)
            this.form.expiry_date = ts >= 1e12 ? ts : ts * 1000
          }
        })
      }
    }

    getWorkerTypeList () {
      apiWorkerTypeList().then((res: any) => {
        this.workerTypeList = res || []
      })
    }

    created () {
      this.getWorkerTypeList()
      this.getSalaryRuleDetail()

      // 设置默认生效日期为今天
      if (!this.isEdit) {
        this.form.effective_date = Date.now()
      }
    }
}
